(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[4673],{

/***/ 3047:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$g": () => (/* binding */ PrescriptionStatus),
/* harmony export */   "AW": () => (/* binding */ Route),
/* harmony export */   "II": () => (/* binding */ InventorySearchOrderProperty),
/* harmony export */   "LE": () => (/* binding */ DiagnosisType),
/* harmony export */   "M6": () => (/* binding */ DispenseMethod),
/* harmony export */   "MG": () => (/* binding */ VisitCareEventAction),
/* harmony export */   "Ne": () => (/* binding */ SupplyLevel),
/* harmony export */   "Ti": () => (/* binding */ StockTakeLotsSearchOrder),
/* harmony export */   "U": () => (/* binding */ NigeriaDailyOutpatientOutcome),
/* harmony export */   "UE": () => (/* binding */ MaritalStatus),
/* harmony export */   "Uy": () => (/* binding */ AdministrationApproach),
/* harmony export */   "Vd": () => (/* binding */ DischargeOutcome),
/* harmony export */   "Vn": () => (/* binding */ DefaultScope),
/* harmony export */   "Wp": () => (/* binding */ RegisterType),
/* harmony export */   "Y8": () => (/* binding */ NationalIdOwner),
/* harmony export */   "Ze": () => (/* binding */ AncEncounterStatus),
/* harmony export */   "_n": () => (/* binding */ ItemPriceOwner),
/* harmony export */   "bG": () => (/* binding */ PaymentStatus),
/* harmony export */   "eC": () => (/* binding */ Dependent),
/* harmony export */   "em": () => (/* binding */ NigeriaDailyOutpatientHepatitisResult),
/* harmony export */   "gW": () => (/* binding */ ClinicalEventType),
/* harmony export */   "iU": () => (/* binding */ TransactionType),
/* harmony export */   "is": () => (/* binding */ AdministeredMedicationTakenFrom),
/* harmony export */   "kA": () => (/* binding */ PriceableItemLanguage),
/* harmony export */   "kg": () => (/* binding */ StockTakeSearchOrderDirection),
/* harmony export */   "l1": () => (/* binding */ PriceableItemOrigin),
/* harmony export */   "lc": () => (/* binding */ TriageStatusType),
/* harmony export */   "ly": () => (/* binding */ RegisterDownloadStatus),
/* harmony export */   "n1": () => (/* binding */ AncInvestigationOutcome),
/* harmony export */   "nk": () => (/* binding */ PayerType),
/* harmony export */   "r": () => (/* binding */ AdministeredOutcome),
/* harmony export */   "t_": () => (/* binding */ ContactPointSystem),
/* harmony export */   "u": () => (/* binding */ DataExportStatus),
/* harmony export */   "uW": () => (/* binding */ NigeriaDailyOutpatientAttendance),
/* harmony export */   "uo": () => (/* binding */ NigeriaDailyOutpatientPreReferralTreatment),
/* harmony export */   "vI": () => (/* binding */ NationalIdType),
/* harmony export */   "xH": () => (/* binding */ InventoryMoveRequestStatus),
/* harmony export */   "yV": () => (/* binding */ NigeriaDailyOutpatientMalariaDiagnosis)
/* harmony export */ });
/* unused harmony exports ProductType, AdministrationScheduleSummaryStatus, Gender, TimeUnit, RateUnit, InventorySupplyLevel, VisitExpiryStrategy, PatientHasInsurance, ContactPointOwnership, ContactRelationship, InsuranceScheme, InsuranceCurrency, ClaimType, ClaimDiagnosisCoding, Policy, AttendanceType, OutcomeType, ServiceType, SpecialityCode, ClaimStatus, InsurancePrescribingLevel, TariffCategory, FacilityType, ClinicalProductType, BillingCurrency, InvoiceStatus, PriceListItemType, InvoiceContactPointOwnership, InvoiceContactPointSystem, InvoiceGender, PatientType, PaymentMethod, TransactionStatus, DownloadColumnFilterValues, DepartmentColor, StockLocationTag, Comparator, InventoryMoveRequestsOptionsOrderBy, OrderDirection, NigeriaDailyOutpatientGbvCase, PriceTariffExternalReferenceOrigin, SearchProductType, StockTakeLotStatus, VisitWithFilteredNotesRole, ExportFormat, CardType, ChangeReason, ApiAdminRole, ResolverScope, Role */
var AdministeredMedicationTakenFrom = /* @__PURE__ */ ((AdministeredMedicationTakenFrom2) => {
  AdministeredMedicationTakenFrom2["NewInventory"] = "NEW_INVENTORY";
  AdministeredMedicationTakenFrom2["OpenInventory"] = "OPEN_INVENTORY";
  AdministeredMedicationTakenFrom2["PatientPurchased"] = "PATIENT_PURCHASED";
  return AdministeredMedicationTakenFrom2;
})(AdministeredMedicationTakenFrom || {});
var AdministeredOutcome = /* @__PURE__ */ ((AdministeredOutcome2) => {
  AdministeredOutcome2["Cancelled"] = "CANCELLED";
  AdministeredOutcome2["Missed"] = "MISSED";
  AdministeredOutcome2["Refused"] = "REFUSED";
  AdministeredOutcome2["Taken"] = "TAKEN";
  return AdministeredOutcome2;
})(AdministeredOutcome || {});
var AdministrationApproach = /* @__PURE__ */ ((AdministrationApproach2) => {
  AdministrationApproach2["AsRequired"] = "AS_REQUIRED";
  AdministrationApproach2["Outpatient"] = "OUTPATIENT";
  AdministrationApproach2["Scheduled"] = "SCHEDULED";
  AdministrationApproach2["Stat"] = "STAT";
  return AdministrationApproach2;
})(AdministrationApproach || {});
var ClinicalEventType = /* @__PURE__ */ ((ClinicalEventType2) => {
  ClinicalEventType2["AncEncounter"] = "ANC_ENCOUNTER";
  ClinicalEventType2["Consultation"] = "CONSULTATION";
  ClinicalEventType2["Visit"] = "VISIT";
  return ClinicalEventType2;
})(ClinicalEventType || {});
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["Amp"] = "amp";
  ProductType2["Vmp"] = "vmp";
  ProductType2["Vtm"] = "vtm";
  return ProductType2;
})(ProductType || {});
var SupplyLevel = /* @__PURE__ */ ((SupplyLevel2) => {
  SupplyLevel2["InStock"] = "IN_STOCK";
  SupplyLevel2["InStockButNotAtYourLocation"] = "IN_STOCK_BUT_NOT_AT_YOUR_LOCATION";
  SupplyLevel2["LowStock"] = "LOW_STOCK";
  SupplyLevel2["NeverBeenStocked"] = "NEVER_BEEN_STOCKED";
  SupplyLevel2["OutOfStock"] = "OUT_OF_STOCK";
  return SupplyLevel2;
})(SupplyLevel || {});
var AdministrationScheduleSummaryStatus = /* @__PURE__ */ ((AdministrationScheduleSummaryStatus2) => {
  AdministrationScheduleSummaryStatus2["Cancelled"] = "CANCELLED";
  AdministrationScheduleSummaryStatus2["Complete"] = "COMPLETE";
  AdministrationScheduleSummaryStatus2["Incomplete"] = "INCOMPLETE";
  AdministrationScheduleSummaryStatus2["Pending"] = "PENDING";
  return AdministrationScheduleSummaryStatus2;
})(AdministrationScheduleSummaryStatus || {});
var Gender = /* @__PURE__ */ ((Gender2) => {
  Gender2["F"] = "f";
  Gender2["M"] = "m";
  Gender2["Transgender"] = "transgender";
  return Gender2;
})(Gender || {});
var TimeUnit = /* @__PURE__ */ ((TimeUnit2) => {
  TimeUnit2["Day"] = "DAY";
  TimeUnit2["Hour"] = "HOUR";
  TimeUnit2["Month"] = "MONTH";
  TimeUnit2["Week"] = "WEEK";
  return TimeUnit2;
})(TimeUnit || {});
var RateUnit = /* @__PURE__ */ ((RateUnit2) => {
  RateUnit2["Day"] = "DAY";
  RateUnit2["Hour"] = "HOUR";
  RateUnit2["MlHour"] = "ML_HOUR";
  RateUnit2["Month"] = "MONTH";
  RateUnit2["Week"] = "WEEK";
  return RateUnit2;
})(RateUnit || {});
var Route = /* @__PURE__ */ ((Route2) => {
  Route2["Buccal"] = "BUCCAL";
  Route2["Ear"] = "EAR";
  Route2["Eye"] = "EYE";
  Route2["Inhalation"] = "INHALATION";
  Route2["Intramuscular"] = "INTRAMUSCULAR";
  Route2["Intravenous"] = "INTRAVENOUS";
  Route2["Nasal"] = "NASAL";
  Route2["Nasogastric"] = "NASOGASTRIC";
  Route2["Oral"] = "ORAL";
  Route2["Rectal"] = "RECTAL";
  Route2["Subcutaneous"] = "SUBCUTANEOUS";
  Route2["Sublingual"] = "SUBLINGUAL";
  Route2["Topical"] = "TOPICAL";
  Route2["Unknown"] = "UNKNOWN";
  Route2["Vaginal"] = "VAGINAL";
  return Route2;
})(Route || {});
var PrescriptionStatus = /* @__PURE__ */ ((PrescriptionStatus2) => {
  PrescriptionStatus2["Active"] = "ACTIVE";
  PrescriptionStatus2["Cancelled"] = "CANCELLED";
  PrescriptionStatus2["Completed"] = "COMPLETED";
  PrescriptionStatus2["Expired"] = "EXPIRED";
  return PrescriptionStatus2;
})(PrescriptionStatus || {});
var AncInvestigationOutcome = /* @__PURE__ */ ((AncInvestigationOutcome2) => {
  AncInvestigationOutcome2["Negative"] = "NEGATIVE";
  AncInvestigationOutcome2["Positive"] = "POSITIVE";
  AncInvestigationOutcome2["Referred"] = "REFERRED";
  AncInvestigationOutcome2["Treated"] = "TREATED";
  return AncInvestigationOutcome2;
})(AncInvestigationOutcome || {});
var InventorySupplyLevel = /* @__PURE__ */ ((InventorySupplyLevel2) => {
  InventorySupplyLevel2["InStock"] = "IN_STOCK";
  InventorySupplyLevel2["InStockButNotAtYourLocation"] = "IN_STOCK_BUT_NOT_AT_YOUR_LOCATION";
  InventorySupplyLevel2["LowStock"] = "LOW_STOCK";
  InventorySupplyLevel2["NeverBeenStocked"] = "NEVER_BEEN_STOCKED";
  InventorySupplyLevel2["OutOfStock"] = "OUT_OF_STOCK";
  return InventorySupplyLevel2;
})(InventorySupplyLevel || {});
var DiagnosisType = /* @__PURE__ */ ((DiagnosisType2) => {
  DiagnosisType2["Disease"] = "DISEASE";
  DiagnosisType2["Freetext"] = "FREETEXT";
  return DiagnosisType2;
})(DiagnosisType || {});
var DischargeOutcome = /* @__PURE__ */ ((DischargeOutcome2) => {
  DischargeOutcome2["Absconded"] = "ABSCONDED";
  DischargeOutcome2["Death"] = "DEATH";
  DischargeOutcome2["DischargedHome"] = "DISCHARGED_HOME";
  DischargeOutcome2["Referral"] = "REFERRAL";
  DischargeOutcome2["SelfDischarge"] = "SELF_DISCHARGE";
  return DischargeOutcome2;
})(DischargeOutcome || {});
var VisitCareEventAction = /* @__PURE__ */ ((VisitCareEventAction2) => {
  VisitCareEventAction2["Detention"] = "DETENTION";
  VisitCareEventAction2["Diagnosis"] = "DIAGNOSIS";
  VisitCareEventAction2["InpatientAdmission"] = "INPATIENT_ADMISSION";
  VisitCareEventAction2["InpatientCareNote"] = "INPATIENT_CARE_NOTE";
  VisitCareEventAction2["InpatientDischarge"] = "INPATIENT_DISCHARGE";
  VisitCareEventAction2["InpatientMoveDepartment"] = "INPATIENT_MOVE_DEPARTMENT";
  VisitCareEventAction2["InpatientUpdateLocation"] = "INPATIENT_UPDATE_LOCATION";
  VisitCareEventAction2["InvestigationOutcome"] = "INVESTIGATION_OUTCOME";
  VisitCareEventAction2["InvestigationRequest"] = "INVESTIGATION_REQUEST";
  VisitCareEventAction2["InvestigationResults"] = "INVESTIGATION_RESULTS";
  VisitCareEventAction2["MedicineAdministered"] = "MEDICINE_ADMINISTERED";
  VisitCareEventAction2["MedicineDispensed"] = "MEDICINE_DISPENSED";
  VisitCareEventAction2["MedicinePrescribed"] = "MEDICINE_PRESCRIBED";
  VisitCareEventAction2["MedicineStopped"] = "MEDICINE_STOPPED";
  return VisitCareEventAction2;
})(VisitCareEventAction || {});
var VisitExpiryStrategy = /* @__PURE__ */ ((VisitExpiryStrategy2) => {
  VisitExpiryStrategy2["Midnight"] = "MIDNIGHT";
  VisitExpiryStrategy2["UntilDischarged"] = "UNTIL_DISCHARGED";
  return VisitExpiryStrategy2;
})(VisitExpiryStrategy || {});
var PatientHasInsurance = /* @__PURE__ */ ((PatientHasInsurance2) => {
  PatientHasInsurance2["No"] = "NO";
  PatientHasInsurance2["Unknown"] = "UNKNOWN";
  PatientHasInsurance2["Yes"] = "YES";
  return PatientHasInsurance2;
})(PatientHasInsurance || {});
var ContactPointOwnership = /* @__PURE__ */ ((ContactPointOwnership2) => {
  ContactPointOwnership2["Personal"] = "personal";
  ContactPointOwnership2["Shared"] = "shared";
  return ContactPointOwnership2;
})(ContactPointOwnership || {});
var ContactPointSystem = /* @__PURE__ */ ((ContactPointSystem2) => {
  ContactPointSystem2["Email"] = "email";
  ContactPointSystem2["Fax"] = "fax";
  ContactPointSystem2["Other"] = "other";
  ContactPointSystem2["Pager"] = "pager";
  ContactPointSystem2["Phone"] = "phone";
  return ContactPointSystem2;
})(ContactPointSystem || {});
var ContactRelationship = /* @__PURE__ */ ((ContactRelationship2) => {
  ContactRelationship2["N"] = "N";
  ContactRelationship2["S"] = "S";
  return ContactRelationship2;
})(ContactRelationship || {});
var MaritalStatus = /* @__PURE__ */ ((MaritalStatus2) => {
  MaritalStatus2["A"] = "A";
  MaritalStatus2["I"] = "I";
  MaritalStatus2["L"] = "L";
  MaritalStatus2["M"] = "M";
  MaritalStatus2["P"] = "P";
  MaritalStatus2["S"] = "S";
  MaritalStatus2["T"] = "T";
  MaritalStatus2["U"] = "U";
  MaritalStatus2["Unk"] = "UNK";
  MaritalStatus2["W"] = "W";
  return MaritalStatus2;
})(MaritalStatus || {});
var NationalIdOwner = /* @__PURE__ */ ((NationalIdOwner2) => {
  NationalIdOwner2["Brother"] = "brother";
  NationalIdOwner2["BrotherInLaw"] = "brotherInLaw";
  NationalIdOwner2["Daughter"] = "daughter";
  NationalIdOwner2["Father"] = "father";
  NationalIdOwner2["FatherInLaw"] = "fatherInLaw";
  NationalIdOwner2["Husband"] = "husband";
  NationalIdOwner2["Mother"] = "mother";
  NationalIdOwner2["MotherInLaw"] = "motherInLaw";
  NationalIdOwner2["Other"] = "other";
  NationalIdOwner2["Sister"] = "sister";
  NationalIdOwner2["SisterInLaw"] = "sisterInLaw";
  NationalIdOwner2["Son"] = "son";
  NationalIdOwner2["Wife"] = "wife";
  return NationalIdOwner2;
})(NationalIdOwner || {});
var NationalIdType = /* @__PURE__ */ ((NationalIdType2) => {
  NationalIdType2["Primary"] = "primary";
  NationalIdType2["Secondary"] = "secondary";
  return NationalIdType2;
})(NationalIdType || {});
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["Paid"] = "PAID";
  PaymentStatus2["Unpaid"] = "UNPAID";
  return PaymentStatus2;
})(PaymentStatus || {});
var AncEncounterStatus = /* @__PURE__ */ ((AncEncounterStatus2) => {
  AncEncounterStatus2["Cancelled"] = "CANCELLED";
  AncEncounterStatus2["Completed"] = "COMPLETED";
  AncEncounterStatus2["Discharged"] = "DISCHARGED";
  AncEncounterStatus2["Discontinued"] = "DISCONTINUED";
  AncEncounterStatus2["EnteredInError"] = "ENTERED_IN_ERROR";
  AncEncounterStatus2["InProgress"] = "IN_PROGRESS";
  AncEncounterStatus2["OnHold"] = "ON_HOLD";
  AncEncounterStatus2["Planned"] = "PLANNED";
  AncEncounterStatus2["Unknown"] = "UNKNOWN";
  return AncEncounterStatus2;
})(AncEncounterStatus || {});
var InsuranceScheme = /* @__PURE__ */ ((InsuranceScheme2) => {
  InsuranceScheme2["Lm"] = "LM";
  InsuranceScheme2["Nhif"] = "NHIF";
  InsuranceScheme2["Nhis"] = "NHIS";
  return InsuranceScheme2;
})(InsuranceScheme || {});
var InsuranceCurrency = /* @__PURE__ */ ((InsuranceCurrency2) => {
  InsuranceCurrency2["Ghs"] = "GHS";
  InsuranceCurrency2["Kes"] = "KES";
  InsuranceCurrency2["Ngn"] = "NGN";
  return InsuranceCurrency2;
})(InsuranceCurrency || {});
var ClaimType = /* @__PURE__ */ ((ClaimType2) => {
  ClaimType2["GhanaNhis"] = "GHANA_NHIS";
  ClaimType2["KenyaLm"] = "KENYA_LM";
  ClaimType2["KenyaNhif"] = "KENYA_NHIF";
  return ClaimType2;
})(ClaimType || {});
var ClaimDiagnosisCoding = /* @__PURE__ */ ((ClaimDiagnosisCoding2) => {
  ClaimDiagnosisCoding2["Icd10"] = "icd10";
  ClaimDiagnosisCoding2["Icd11"] = "icd11";
  return ClaimDiagnosisCoding2;
})(ClaimDiagnosisCoding || {});
var Policy = /* @__PURE__ */ ((Policy2) => {
  Policy2["ChagHealthCentreAndClinic"] = "CHAG_HEALTH_CENTRE_AND_CLINIC";
  Policy2["ChagPrimaryCareHospitalCateringExcl"] = "CHAG_PRIMARY_CARE_HOSPITAL_CATERING_EXCL";
  Policy2["ChagPrimaryCareHospitalCateringIncl"] = "CHAG_PRIMARY_CARE_HOSPITAL_CATERING_INCL";
  Policy2["PrivateClinic"] = "PRIVATE_CLINIC";
  Policy2["PrivateDentalCentres"] = "PRIVATE_DENTAL_CENTRES";
  Policy2["PrivateDiagnosticCentre"] = "PRIVATE_DIAGNOSTIC_CENTRE";
  Policy2["PrivateEyeCentres"] = "PRIVATE_EYE_CENTRES";
  Policy2["PrivateHealthCentreAndMaternityHome"] = "PRIVATE_HEALTH_CENTRE_AND_MATERNITY_HOME";
  Policy2["PrivatePrimaryCareHospitalCateringExcl"] = "PRIVATE_PRIMARY_CARE_HOSPITAL_CATERING_EXCL";
  Policy2["PrivatePrimaryCareHospitalCateringIncl"] = "PRIVATE_PRIMARY_CARE_HOSPITAL_CATERING_INCL";
  Policy2["PrivateSecondaryHospital"] = "PRIVATE_SECONDARY_HOSPITAL";
  Policy2["PublicChpsCompound"] = "PUBLIC_CHPS_COMPOUND";
  Policy2["PublicHealthCentre"] = "PUBLIC_HEALTH_CENTRE";
  Policy2["PublicPrimaryCareHospitalCateringExcl"] = "PUBLIC_PRIMARY_CARE_HOSPITAL_CATERING_EXCL";
  Policy2["PublicPrimaryCareHospitalCateringIncl"] = "PUBLIC_PRIMARY_CARE_HOSPITAL_CATERING_INCL";
  Policy2["PublicSecondaryHospital"] = "PUBLIC_SECONDARY_HOSPITAL";
  Policy2["PublicTertiaryHospital"] = "PUBLIC_TERTIARY_HOSPITAL";
  return Policy2;
})(Policy || {});
var AttendanceType = /* @__PURE__ */ ((_AttendanceType) => {
  _AttendanceType["Acute"] = "ACUTE";
  _AttendanceType["Anc"] = "ANC";
  _AttendanceType["AttendanceType"] = "ATTENDANCE_TYPE";
  _AttendanceType["Chronic"] = "CHRONIC";
  _AttendanceType["Emergency"] = "EMERGENCY";
  _AttendanceType["ServiceProvided"] = "SERVICE_PROVIDED";
  return _AttendanceType;
})(AttendanceType || {});
var OutcomeType = /* @__PURE__ */ ((OutcomeType2) => {
  OutcomeType2["Absconded"] = "ABSCONDED";
  OutcomeType2["Dead"] = "DEAD";
  OutcomeType2["Discharged"] = "DISCHARGED";
  OutcomeType2["DischargedAgainstAdvice"] = "DISCHARGED_AGAINST_ADVICE";
  OutcomeType2["ServiceProvided"] = "SERVICE_PROVIDED";
  OutcomeType2["Transferred"] = "TRANSFERRED";
  return OutcomeType2;
})(OutcomeType || {});
var ServiceType = /* @__PURE__ */ ((ServiceType2) => {
  ServiceType2["Diagnostic"] = "DIAGNOSTIC";
  ServiceType2["Inpatient"] = "INPATIENT";
  ServiceType2["Outpatient"] = "OUTPATIENT";
  return ServiceType2;
})(ServiceType || {});
var SpecialityCode = /* @__PURE__ */ ((SpecialityCode2) => {
  SpecialityCode2["Asur"] = "ASUR";
  SpecialityCode2["Dent"] = "DENT";
  SpecialityCode2["Enth"] = "ENTH";
  SpecialityCode2["Medi"] = "MEDI";
  SpecialityCode2["Obgy"] = "OBGY";
  SpecialityCode2["Opdc"] = "OPDC";
  SpecialityCode2["Opht"] = "OPHT";
  SpecialityCode2["Orth"] = "ORTH";
  SpecialityCode2["Paed"] = "PAED";
  SpecialityCode2["Psur"] = "PSUR";
  SpecialityCode2["Rsur"] = "RSUR";
  return SpecialityCode2;
})(SpecialityCode || {});
var ClaimStatus = /* @__PURE__ */ ((ClaimStatus2) => {
  ClaimStatus2["Complete"] = "COMPLETE";
  ClaimStatus2["Discarded"] = "DISCARDED";
  ClaimStatus2["Edited"] = "EDITED";
  ClaimStatus2["Exported"] = "EXPORTED";
  ClaimStatus2["New"] = "NEW";
  return ClaimStatus2;
})(ClaimStatus || {});
var InsurancePrescribingLevel = /* @__PURE__ */ ((InsurancePrescribingLevel2) => {
  InsurancePrescribingLevel2["A"] = "A";
  InsurancePrescribingLevel2["B1"] = "B1";
  InsurancePrescribingLevel2["B2"] = "B2";
  InsurancePrescribingLevel2["C"] = "C";
  InsurancePrescribingLevel2["D"] = "D";
  InsurancePrescribingLevel2["M"] = "M";
  InsurancePrescribingLevel2["Sm"] = "SM";
  return InsurancePrescribingLevel2;
})(InsurancePrescribingLevel || {});
var TariffCategory = /* @__PURE__ */ ((TariffCategory2) => {
  TariffCategory2["AdultSurgery"] = "ADULT_SURGERY";
  TariffCategory2["Dental"] = "DENTAL";
  TariffCategory2["EarNoseAndThroat"] = "EAR_NOSE_AND_THROAT";
  TariffCategory2["Investigation"] = "INVESTIGATION";
  TariffCategory2["Medical"] = "MEDICAL";
  TariffCategory2["Medicines"] = "MEDICINES";
  TariffCategory2["ObstetricsAndGynaecology"] = "OBSTETRICS_AND_GYNAECOLOGY";
  TariffCategory2["Ophthalmology"] = "OPHTHALMOLOGY";
  TariffCategory2["Orthopaedics"] = "ORTHOPAEDICS";
  TariffCategory2["Outpatient"] = "OUTPATIENT";
  TariffCategory2["PaediatricSurgery"] = "PAEDIATRIC_SURGERY";
  TariffCategory2["Paediatrics"] = "PAEDIATRICS";
  TariffCategory2["ReconstructiveSurgery"] = "RECONSTRUCTIVE_SURGERY";
  TariffCategory2["Zoom"] = "ZOOM";
  return TariffCategory2;
})(TariffCategory || {});
var FacilityType = /* @__PURE__ */ ((FacilityType2) => {
  FacilityType2["ChagHealthCentreAndClinic"] = "CHAG_HEALTH_CENTRE_AND_CLINIC";
  FacilityType2["ChagPrimaryCareHospitalCateringExcl"] = "CHAG_PRIMARY_CARE_HOSPITAL_CATERING_EXCL";
  FacilityType2["ChagPrimaryCareHospitalCateringIncl"] = "CHAG_PRIMARY_CARE_HOSPITAL_CATERING_INCL";
  FacilityType2["PrivateClinic"] = "PRIVATE_CLINIC";
  FacilityType2["PrivateDentalCentres"] = "PRIVATE_DENTAL_CENTRES";
  FacilityType2["PrivateDiagnosticCentre"] = "PRIVATE_DIAGNOSTIC_CENTRE";
  FacilityType2["PrivateEyeCentres"] = "PRIVATE_EYE_CENTRES";
  FacilityType2["PrivateHealthCentreAndMaternityHome"] = "PRIVATE_HEALTH_CENTRE_AND_MATERNITY_HOME";
  FacilityType2["PrivatePrimaryCareHospitalCateringExcl"] = "PRIVATE_PRIMARY_CARE_HOSPITAL_CATERING_EXCL";
  FacilityType2["PrivatePrimaryCareHospitalCateringIncl"] = "PRIVATE_PRIMARY_CARE_HOSPITAL_CATERING_INCL";
  FacilityType2["PrivateSecondaryHospital"] = "PRIVATE_SECONDARY_HOSPITAL";
  FacilityType2["PublicChpsCompound"] = "PUBLIC_CHPS_COMPOUND";
  FacilityType2["PublicHealthCentre"] = "PUBLIC_HEALTH_CENTRE";
  FacilityType2["PublicPrimaryCareHospitalCateringExcl"] = "PUBLIC_PRIMARY_CARE_HOSPITAL_CATERING_EXCL";
  FacilityType2["PublicPrimaryCareHospitalCateringIncl"] = "PUBLIC_PRIMARY_CARE_HOSPITAL_CATERING_INCL";
  FacilityType2["PublicSecondaryHospital"] = "PUBLIC_SECONDARY_HOSPITAL";
  FacilityType2["PublicTertiaryHospital"] = "PUBLIC_TERTIARY_HOSPITAL";
  return FacilityType2;
})(FacilityType || {});
var ClinicalProductType = /* @__PURE__ */ ((ClinicalProductType2) => {
  ClinicalProductType2["Amp"] = "AMP";
  ClinicalProductType2["Vmp"] = "VMP";
  return ClinicalProductType2;
})(ClinicalProductType || {});
var BillingCurrency = /* @__PURE__ */ ((BillingCurrency2) => {
  BillingCurrency2["Ghs"] = "GHS";
  BillingCurrency2["Kes"] = "KES";
  BillingCurrency2["Ngn"] = "NGN";
  BillingCurrency2["Pkr"] = "PKR";
  return BillingCurrency2;
})(BillingCurrency || {});
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["Draft"] = "DRAFT";
  InvoiceStatus2["Paid"] = "PAID";
  InvoiceStatus2["PartiallyPaid"] = "PARTIALLY_PAID";
  InvoiceStatus2["PartiallyRefunded"] = "PARTIALLY_REFUNDED";
  InvoiceStatus2["Refunded"] = "REFUNDED";
  InvoiceStatus2["Unpaid"] = "UNPAID";
  InvoiceStatus2["Void"] = "VOID";
  return InvoiceStatus2;
})(InvoiceStatus || {});
var PriceableItemOrigin = /* @__PURE__ */ ((PriceableItemOrigin2) => {
  PriceableItemOrigin2["Custom"] = "CUSTOM";
  PriceableItemOrigin2["General"] = "GENERAL";
  PriceableItemOrigin2["Inventory"] = "INVENTORY";
  PriceableItemOrigin2["Investigation"] = "INVESTIGATION";
  PriceableItemOrigin2["Procedure"] = "PROCEDURE";
  return PriceableItemOrigin2;
})(PriceableItemOrigin || {});
var PriceListItemType = /* @__PURE__ */ ((PriceListItemType2) => {
  PriceListItemType2["Admin"] = "Admin";
  PriceListItemType2["Consultation"] = "Consultation";
  PriceListItemType2["Investigation"] = "Investigation";
  PriceListItemType2["Other"] = "Other";
  PriceListItemType2["Prescription"] = "Prescription";
  PriceListItemType2["Procedure"] = "Procedure";
  return PriceListItemType2;
})(PriceListItemType || {});
var InvoiceContactPointOwnership = /* @__PURE__ */ ((InvoiceContactPointOwnership2) => {
  InvoiceContactPointOwnership2["Personal"] = "personal";
  InvoiceContactPointOwnership2["Shared"] = "shared";
  return InvoiceContactPointOwnership2;
})(InvoiceContactPointOwnership || {});
var InvoiceContactPointSystem = /* @__PURE__ */ ((InvoiceContactPointSystem2) => {
  InvoiceContactPointSystem2["Other"] = "other";
  InvoiceContactPointSystem2["Phone"] = "phone";
  return InvoiceContactPointSystem2;
})(InvoiceContactPointSystem || {});
var InvoiceGender = /* @__PURE__ */ ((InvoiceGender2) => {
  InvoiceGender2["F"] = "f";
  InvoiceGender2["M"] = "m";
  InvoiceGender2["Transgender"] = "transgender";
  return InvoiceGender2;
})(InvoiceGender || {});
var PatientType = /* @__PURE__ */ ((PatientType2) => {
  PatientType2["Inpatient"] = "Inpatient";
  PatientType2["Outpatient"] = "Outpatient";
  return PatientType2;
})(PatientType || {});
var Dependent = /* @__PURE__ */ ((Dependent2) => {
  Dependent2["Child"] = "CHILD";
  Dependent2["Dependentchild"] = "DEPENDENTCHILD";
  Dependent2["Dependentspouse"] = "DEPENDENTSPOUSE";
  Dependent2["Member"] = "MEMBER";
  Dependent2["Spouse"] = "SPOUSE";
  return Dependent2;
})(Dependent || {});
var PayerType = /* @__PURE__ */ ((PayerType2) => {
  PayerType2["Exempt"] = "EXEMPT";
  PayerType2["Insurer"] = "INSURER";
  PayerType2["Patient"] = "PATIENT";
  PayerType2["Void"] = "VOID";
  PayerType2["Waiver"] = "WAIVER";
  return PayerType2;
})(PayerType || {});
var PaymentMethod = /* @__PURE__ */ ((PaymentMethod2) => {
  PaymentMethod2["Cash"] = "CASH";
  PaymentMethod2["Mpesa"] = "MPESA";
  PaymentMethod2["Other"] = "OTHER";
  PaymentMethod2["Void"] = "VOID";
  return PaymentMethod2;
})(PaymentMethod || {});
var TransactionStatus = /* @__PURE__ */ ((TransactionStatus2) => {
  TransactionStatus2["Fail"] = "FAIL";
  TransactionStatus2["Pending"] = "PENDING";
  TransactionStatus2["Success"] = "SUCCESS";
  return TransactionStatus2;
})(TransactionStatus || {});
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["ChargeInsurer"] = "CHARGE_INSURER";
  TransactionType2["Exempt"] = "EXEMPT";
  TransactionType2["Payment"] = "PAYMENT";
  TransactionType2["Refund"] = "REFUND";
  TransactionType2["Void"] = "VOID";
  TransactionType2["Waiver"] = "WAIVER";
  return TransactionType2;
})(TransactionType || {});
var DataExportStatus = /* @__PURE__ */ ((DataExportStatus2) => {
  DataExportStatus2["Complete"] = "Complete";
  DataExportStatus2["Error"] = "Error";
  DataExportStatus2["Expired"] = "Expired";
  DataExportStatus2["Processing"] = "Processing";
  return DataExportStatus2;
})(DataExportStatus || {});
var DownloadColumnFilterValues = /* @__PURE__ */ ((DownloadColumnFilterValues2) => {
  DownloadColumnFilterValues2["Address"] = "address";
  DownloadColumnFilterValues2["Age"] = "age";
  DownloadColumnFilterValues2["Date"] = "date";
  DownloadColumnFilterValues2["Diagnoses"] = "diagnoses";
  DownloadColumnFilterValues2["Investigations"] = "investigations";
  DownloadColumnFilterValues2["InvestigationTests"] = "investigationTests";
  DownloadColumnFilterValues2["Name"] = "name";
  DownloadColumnFilterValues2["Phone"] = "phone";
  DownloadColumnFilterValues2["Prescriptions"] = "prescriptions";
  DownloadColumnFilterValues2["Sex"] = "sex";
  DownloadColumnFilterValues2["TestValues"] = "testValues";
  return DownloadColumnFilterValues2;
})(DownloadColumnFilterValues || {});
var DepartmentColor = /* @__PURE__ */ ((DepartmentColor2) => {
  DepartmentColor2["Blue"] = "BLUE";
  DepartmentColor2["Pink"] = "PINK";
  DepartmentColor2["Purple"] = "PURPLE";
  DepartmentColor2["Turquoise"] = "TURQUOISE";
  DepartmentColor2["Yellow"] = "YELLOW";
  return DepartmentColor2;
})(DepartmentColor || {});
var StockLocationTag = /* @__PURE__ */ ((StockLocationTag2) => {
  StockLocationTag2["CheckInArea"] = "CHECK_IN_AREA";
  StockLocationTag2["Department"] = "DEPARTMENT";
  StockLocationTag2["DispensingArea"] = "DISPENSING_AREA";
  StockLocationTag2["ExternalFacility"] = "EXTERNAL_FACILITY";
  StockLocationTag2["Inpatient"] = "INPATIENT";
  StockLocationTag2["StorageArea"] = "STORAGE_AREA";
  return StockLocationTag2;
})(StockLocationTag || {});
var Comparator = /* @__PURE__ */ ((Comparator2) => {
  Comparator2["Eq"] = "EQ";
  Comparator2["Gt"] = "GT";
  Comparator2["Gte"] = "GTE";
  Comparator2["Lt"] = "LT";
  Comparator2["Lte"] = "LTE";
  Comparator2["Neq"] = "NEQ";
  return Comparator2;
})(Comparator || {});
var InventoryMoveRequestStatus = /* @__PURE__ */ ((InventoryMoveRequestStatus2) => {
  InventoryMoveRequestStatus2["Fulfilled"] = "FULFILLED";
  InventoryMoveRequestStatus2["Pending"] = "PENDING";
  InventoryMoveRequestStatus2["Rejected"] = "REJECTED";
  return InventoryMoveRequestStatus2;
})(InventoryMoveRequestStatus || {});
var InventoryMoveRequestsOptionsOrderBy = /* @__PURE__ */ ((InventoryMoveRequestsOptionsOrderBy2) => {
  InventoryMoveRequestsOptionsOrderBy2["CreatedAt"] = "CREATED_AT";
  return InventoryMoveRequestsOptionsOrderBy2;
})(InventoryMoveRequestsOptionsOrderBy || {});
var OrderDirection = /* @__PURE__ */ ((OrderDirection2) => {
  OrderDirection2["Asc"] = "ASC";
  OrderDirection2["Desc"] = "DESC";
  return OrderDirection2;
})(OrderDirection || {});
var InventorySearchOrderProperty = /* @__PURE__ */ ((InventorySearchOrderProperty2) => {
  InventorySearchOrderProperty2["ExpiryDate"] = "EXPIRY_DATE";
  InventorySearchOrderProperty2["Name"] = "NAME";
  InventorySearchOrderProperty2["NameRelavance"] = "NAME_RELAVANCE";
  InventorySearchOrderProperty2["StockLevel"] = "STOCK_LEVEL";
  InventorySearchOrderProperty2["UpdatedAt"] = "UPDATED_AT";
  return InventorySearchOrderProperty2;
})(InventorySearchOrderProperty || {});
var NigeriaDailyOutpatientAttendance = /* @__PURE__ */ ((NigeriaDailyOutpatientAttendance2) => {
  NigeriaDailyOutpatientAttendance2["FollowUp"] = "FOLLOW_UP";
  NigeriaDailyOutpatientAttendance2["New"] = "NEW";
  return NigeriaDailyOutpatientAttendance2;
})(NigeriaDailyOutpatientAttendance || {});
var NigeriaDailyOutpatientGbvCase = /* @__PURE__ */ ((NigeriaDailyOutpatientGbvCase2) => {
  NigeriaDailyOutpatientGbvCase2["Physical"] = "PHYSICAL";
  NigeriaDailyOutpatientGbvCase2["Pyschological"] = "PYSCHOLOGICAL";
  NigeriaDailyOutpatientGbvCase2["Sexual"] = "SEXUAL";
  return NigeriaDailyOutpatientGbvCase2;
})(NigeriaDailyOutpatientGbvCase || {});
var NigeriaDailyOutpatientHepatitisResult = /* @__PURE__ */ ((NigeriaDailyOutpatientHepatitisResult2) => {
  NigeriaDailyOutpatientHepatitisResult2["NotTested"] = "NOT_TESTED";
  NigeriaDailyOutpatientHepatitisResult2["TestedNegative"] = "TESTED_NEGATIVE";
  NigeriaDailyOutpatientHepatitisResult2["TestedPositiveReferred"] = "TESTED_POSITIVE_REFERRED";
  NigeriaDailyOutpatientHepatitisResult2["TestedPositiveTreated"] = "TESTED_POSITIVE_TREATED";
  return NigeriaDailyOutpatientHepatitisResult2;
})(NigeriaDailyOutpatientHepatitisResult || {});
var NigeriaDailyOutpatientMalariaDiagnosis = /* @__PURE__ */ ((NigeriaDailyOutpatientMalariaDiagnosis2) => {
  NigeriaDailyOutpatientMalariaDiagnosis2["ClinicalDiagnosisOnly"] = "CLINICAL_DIAGNOSIS_ONLY";
  NigeriaDailyOutpatientMalariaDiagnosis2["MicroscopyNeg"] = "MICROSCOPY_NEG";
  NigeriaDailyOutpatientMalariaDiagnosis2["MicroscopyPos"] = "MICROSCOPY_POS";
  NigeriaDailyOutpatientMalariaDiagnosis2["RdtNeg"] = "RDT_NEG";
  NigeriaDailyOutpatientMalariaDiagnosis2["RdtPos"] = "RDT_POS";
  return NigeriaDailyOutpatientMalariaDiagnosis2;
})(NigeriaDailyOutpatientMalariaDiagnosis || {});
var NigeriaDailyOutpatientOutcome = /* @__PURE__ */ ((NigeriaDailyOutpatientOutcome2) => {
  NigeriaDailyOutpatientOutcome2["NotTreated"] = "NOT_TREATED";
  NigeriaDailyOutpatientOutcome2["Referred"] = "REFERRED";
  NigeriaDailyOutpatientOutcome2["Treated"] = "TREATED";
  return NigeriaDailyOutpatientOutcome2;
})(NigeriaDailyOutpatientOutcome || {});
var NigeriaDailyOutpatientPreReferralTreatment = /* @__PURE__ */ ((NigeriaDailyOutpatientPreReferralTreatment2) => {
  NigeriaDailyOutpatientPreReferralTreatment2["ImIvArtesunate"] = "IM_IV_ARTESUNATE";
  NigeriaDailyOutpatientPreReferralTreatment2["IvArtesunate"] = "IV_ARTESUNATE";
  NigeriaDailyOutpatientPreReferralTreatment2["No"] = "NO";
  NigeriaDailyOutpatientPreReferralTreatment2["Other"] = "OTHER";
  return NigeriaDailyOutpatientPreReferralTreatment2;
})(NigeriaDailyOutpatientPreReferralTreatment || {});
var TriageStatusType = /* @__PURE__ */ ((TriageStatusType2) => {
  TriageStatusType2["Blue"] = "BLUE";
  TriageStatusType2["Green"] = "GREEN";
  TriageStatusType2["None"] = "NONE";
  TriageStatusType2["Orange"] = "ORANGE";
  TriageStatusType2["Red"] = "RED";
  TriageStatusType2["Yellow"] = "YELLOW";
  return TriageStatusType2;
})(TriageStatusType || {});
var ItemPriceOwner = /* @__PURE__ */ ((ItemPriceOwner2) => {
  ItemPriceOwner2["Facility"] = "FACILITY";
  ItemPriceOwner2["Organisation"] = "ORGANISATION";
  return ItemPriceOwner2;
})(ItemPriceOwner || {});
var PriceTariffExternalReferenceOrigin = /* @__PURE__ */ ((PriceTariffExternalReferenceOrigin2) => {
  PriceTariffExternalReferenceOrigin2["InsuranceProvider"] = "INSURANCE_PROVIDER";
  return PriceTariffExternalReferenceOrigin2;
})(PriceTariffExternalReferenceOrigin || {});
var SearchProductType = /* @__PURE__ */ ((SearchProductType2) => {
  SearchProductType2["Amps"] = "amps";
  SearchProductType2["Vmps"] = "vmps";
  SearchProductType2["Vtms"] = "vtms";
  return SearchProductType2;
})(SearchProductType || {});
var RegisterDownloadStatus = /* @__PURE__ */ ((RegisterDownloadStatus2) => {
  RegisterDownloadStatus2["Complete"] = "Complete";
  RegisterDownloadStatus2["Error"] = "Error";
  RegisterDownloadStatus2["Expired"] = "Expired";
  RegisterDownloadStatus2["Processing"] = "Processing";
  return RegisterDownloadStatus2;
})(RegisterDownloadStatus || {});
var RegisterType = /* @__PURE__ */ ((RegisterType2) => {
  RegisterType2["Anc"] = "ANC";
  RegisterType2["GenericOpd"] = "GenericOPD";
  RegisterType2["NigeriaDailyOutpatient"] = "NigeriaDailyOutpatient";
  RegisterType2["NigeriaGeneralAttendance"] = "NigeriaGeneralAttendance";
  return RegisterType2;
})(RegisterType || {});
var StockTakeLotsSearchOrder = /* @__PURE__ */ ((StockTakeLotsSearchOrder2) => {
  StockTakeLotsSearchOrder2["ExpiryDate"] = "EXPIRY_DATE";
  StockTakeLotsSearchOrder2["LastStockTakeAt"] = "LAST_STOCK_TAKE_AT";
  StockTakeLotsSearchOrder2["Name"] = "NAME";
  StockTakeLotsSearchOrder2["NameRelevance"] = "NAME_RELEVANCE";
  StockTakeLotsSearchOrder2["QuantityDifference"] = "QUANTITY_DIFFERENCE";
  return StockTakeLotsSearchOrder2;
})(StockTakeLotsSearchOrder || {});
var StockTakeSearchOrderDirection = /* @__PURE__ */ ((StockTakeSearchOrderDirection2) => {
  StockTakeSearchOrderDirection2["Asc"] = "ASC";
  StockTakeSearchOrderDirection2["Desc"] = "DESC";
  return StockTakeSearchOrderDirection2;
})(StockTakeSearchOrderDirection || {});
var StockTakeLotStatus = /* @__PURE__ */ ((StockTakeLotStatus2) => {
  StockTakeLotStatus2["Completed"] = "COMPLETED";
  StockTakeLotStatus2["Errored"] = "ERRORED";
  StockTakeLotStatus2["Pending"] = "PENDING";
  return StockTakeLotStatus2;
})(StockTakeLotStatus || {});
var DefaultScope = /* @__PURE__ */ ((DefaultScope2) => {
  DefaultScope2["Clinic"] = "CLINIC";
  DefaultScope2["Organisation"] = "ORGANISATION";
  DefaultScope2["User"] = "USER";
  return DefaultScope2;
})(DefaultScope || {});
var VisitWithFilteredNotesRole = /* @__PURE__ */ ((VisitWithFilteredNotesRole2) => {
  VisitWithFilteredNotesRole2["Doctor"] = "DOCTOR";
  VisitWithFilteredNotesRole2["Nurse"] = "NURSE";
  return VisitWithFilteredNotesRole2;
})(VisitWithFilteredNotesRole || {});
var DispenseMethod = /* @__PURE__ */ ((DispenseMethod2) => {
  DispenseMethod2["Alternative"] = "ALTERNATIVE";
  DispenseMethod2["Paper"] = "PAPER";
  DispenseMethod2["Prescribed"] = "PRESCRIBED";
  return DispenseMethod2;
})(DispenseMethod || {});
var ExportFormat = /* @__PURE__ */ ((ExportFormat2) => {
  ExportFormat2["ExcelNhis"] = "EXCEL_NHIS";
  ExportFormat2["Xml"] = "XML";
  ExportFormat2["XmlClaimit"] = "XML_CLAIMIT";
  ExportFormat2["XmlNhis"] = "XML_NHIS";
  return ExportFormat2;
})(ExportFormat || {});
var CardType = /* @__PURE__ */ ((CardType2) => {
  CardType2["Ghanacard"] = "GHANACARD";
  CardType2["Nhiscard"] = "NHISCARD";
  return CardType2;
})(CardType || {});
var PriceableItemLanguage = /* @__PURE__ */ ((PriceableItemLanguage2) => {
  PriceableItemLanguage2["EnGb"] = "EN_GB";
  return PriceableItemLanguage2;
})(PriceableItemLanguage || {});
var ChangeReason = /* @__PURE__ */ ((ChangeReason2) => {
  ChangeReason2["Error"] = "ERROR";
  ChangeReason2["Expired"] = "EXPIRED";
  ChangeReason2["Other"] = "OTHER";
  ChangeReason2["StockTake"] = "STOCK_TAKE";
  ChangeReason2["TransferToAnotherFacility"] = "TRANSFER_TO_ANOTHER_FACILITY";
  ChangeReason2["Wastage"] = "WASTAGE";
  return ChangeReason2;
})(ChangeReason || {});
var ApiAdminRole = /* @__PURE__ */ ((ApiAdminRole2) => {
  ApiAdminRole2["Admin"] = "ADMIN";
  ApiAdminRole2["CashOfficer"] = "CASH_OFFICER";
  ApiAdminRole2["Clinic"] = "CLINIC";
  ApiAdminRole2["Dispenser"] = "DISPENSER";
  ApiAdminRole2["Doctor"] = "DOCTOR";
  ApiAdminRole2["Elephant"] = "ELEPHANT";
  ApiAdminRole2["Nurse"] = "NURSE";
  ApiAdminRole2["Pharmacist"] = "PHARMACIST";
  ApiAdminRole2["Root"] = "ROOT";
  ApiAdminRole2["Technician"] = "TECHNICIAN";
  return ApiAdminRole2;
})(ApiAdminRole || {});
var ResolverScope = /* @__PURE__ */ ((ResolverScope2) => {
  ResolverScope2["ClaimsGenerate"] = "CLAIMS_GENERATE";
  ResolverScope2["InvoicesGenerate"] = "INVOICES_GENERATE";
  ResolverScope2["LegacyInvoiceUserMapping"] = "LEGACY_INVOICE_USER_MAPPING";
  ResolverScope2["PatientRegisterDetailsRequest"] = "PATIENT_REGISTER_DETAILS_REQUEST";
  return ResolverScope2;
})(ResolverScope || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["Admin"] = "ADMIN";
  Role2["CashOfficer"] = "CASH_OFFICER";
  Role2["Clinic"] = "CLINIC";
  Role2["Dispenser"] = "DISPENSER";
  Role2["Doctor"] = "DOCTOR";
  Role2["Elephant"] = "ELEPHANT";
  Role2["Nurse"] = "NURSE";
  Role2["Pharmacist"] = "PHARMACIST";
  Role2["Root"] = "ROOT";
  Role2["Technician"] = "TECHNICIAN";
  return Role2;
})(Role || {});


/***/ }),

/***/ 36510:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 60234:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 39565:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 2515:
/***/ (() => {

/* (ignored) */

/***/ })

}]);